<script>
  import { app } from '../../store';

  $: title = [$app?.titleBase, 'Page not found'].join(' | ');

  // BUG: Component bug not binding in svelte probably because we're not exporting value as an official prop
  // BUG: I think we only add value on key up which break bot data on purpose, we might need a flag to allow-fill
</script>

<svelte:head>
  <title>{title}</title>
</svelte:head>

<hgroup>
  <h2>Feature Not Found</h2>
  <h4>Let us know about this</h4>
</hgroup>
